export var isDestinationPluginWithAddMiddleware = function (plugin) {
    // FYI: segment's plugin does not currently have an 'addMiddleware' method
    return 'addMiddleware' in plugin && plugin.type === 'destination';
};
//# sourceMappingURL=index.js.map